import client from 'superagent';
import prefix from 'superagent-prefix';
import agent from 'superagent-use';
import { Response } from './providerResponse';
import { mergeDefaultOptions } from './providerOptions';


function Superagent(prefixString = '') {
    return agent(client).use(prefix(prefixString));
}

function trimSlashes(url) {
    if (/^http/.test(url)) {
        return url;
    }
    return '/' + url.replace(/^\/|\/$/g, '');
}

export function post(url, values, options = {}) {
    const { prefix, dataType } = mergeDefaultOptions(options);

    return new Promise((res, rej) => {
        const s = Superagent(prefix)
            .post(trimSlashes(url))
            .type(dataType)

        if (options.headers) {
            s.set(options.headers);
        }

        s.send(values).end((error, response) => {
            if (error) {
                if (response) {
                    rej(new Response(
                        response.body,
                        response.statusCode,
                        response.statusText ? response.statusText : response.text
                    ));
                } else {
                    rej(new Response(
                        error,
                        401,
                        'Unauthorized'
                    ));
                }
            } else {
                res(new Response(
                    response.body,
                    response.statusCode
                ));
            }
        });
    });
}

export function get(url, params, options = {}) {
    const { prefix } = mergeDefaultOptions(options);

    return new Promise((res, rej) => {
        const s = Superagent(prefix)
            .get(trimSlashes(url));

        if (options.headers) {
            s.set(options.headers);
        }

        s.query(params).end((error, response) => {
                if (error) {
                    if (response) {
                        rej(new Response(
                            response.text !== 'null'
                                ? response.body || response.text
                                : undefined,
                            response.statusCode,
                            response.statusText
                        ));
                    } else {
                        rej(new Response(
                            error,
                            401,
                            'Unauthorized'
                        ));
                    }
                } else {
                    res(new Response(
                        response.text !== 'null'
                            ? response.body || response.text
                            : undefined,
                        response.statusCode
                    ));
                }
            });
    });
}



// WEBPACK FOOTER //
// ./src/services/api/utils/superagentProvider.js